import { createStore } from '@draft-js-plugins/utils';
import React from 'react';
import { AlignTextLeftButton, AlignTextCenterButton, AlignTextRightButton } from '@draft-js-plugins/buttons';

function _extends() {
  // eslint-disable-next-line
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  // eslint-disable-next-line
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Alignment = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Alignment, _React$Component);

  function Alignment() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderAlignmentButtons = function (externalProps) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlignTextLeftButton, externalProps), /*#__PURE__*/React.createElement(AlignTextCenterButton, externalProps), /*#__PURE__*/React.createElement(AlignTextRightButton, externalProps));
    };

    return _this;
  }

  var _proto = Alignment.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        store = _this$props.store,
        theme = _this$props.theme;
    var childrenProps = {
      theme: theme,
      getEditorState: store.getItem('getEditorState'),
      setEditorState: store.getItem('setEditorState')
    };
    return this.renderAlignmentButtons(childrenProps);
  };

  return Alignment;
}(React.Component);

var alignmentStyles = {
  draftLeft: "d1sccg06",
  draftRight: "db0x715",
  draftCenter: "d1ti60k8",
  draftJustify: "d2ti68lp"
};
var defaultTheme = {
  alignmentStyles: alignmentStyles
};

var index = (function (config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      _config$theme = _config.theme,
      theme = _config$theme === void 0 ? defaultTheme : _config$theme;
  var store = createStore();

  var TextAlignment = function TextAlignment(props) {
    return /*#__PURE__*/React.createElement(Alignment, _extends({
      store: store
    }, props));
  };

  var capitalFirstLetter = function capitalFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  var getBlockAlignment = function getBlockAlignment(block) {
    var style = 'left';
    block.findStyleRanges(function (value) {
      if (value.hasStyle('right')) style = 'right';
      if (value.hasStyle('center')) style = 'center';
      if (value.hasStyle('justify')) style = 'justify';
      return true;
    }, function () {
      return true;
    });
    return capitalFirstLetter(style);
  };

  return {
    initialize: function initialize(_ref) {
      var getEditorState = _ref.getEditorState,
          setEditorState = _ref.setEditorState;
      store.updateItem('getEditorState', getEditorState);
      store.updateItem('setEditorState', setEditorState);
    },
    blockStyleFn: function blockStyleFn(block, _ref2) {
      var getEditorState = _ref2.getEditorState;
      var alignment = "draft" + getBlockAlignment(block);

      if (!block.getText()) {
        var previousBlock = getEditorState().getCurrentContent().getBlockBefore(block.getKey());

        if (previousBlock) {
          alignment = "draft" + getBlockAlignment(previousBlock);
        }
      }

      return theme.alignmentStyles[alignment];
    },
    TextAlignment: TextAlignment
  };
});

export { index as default };
